var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"wizard-steps-list"},[_c('ul',{staticClass:"wizard-steps-list__inner"},_vm._l((_vm.steps),function(step,index){return _c('li',{key:index,class:{
                'wizard-steps-list__item': true,
                'is-active': (index === _vm.activeStep - 1),
                'is-completed': (index < _vm.activeStep - 1),
                'pointer': (index <= 1 || _vm.groupKinds.length)
            }},[_c('span',{staticClass:"wizard-steps-list__label",domProps:{"innerHTML":_vm._s(step)},on:{"click":function($event){return _vm.emitStepChanges(index)}}})])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }